import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";


import {setLookOpened, setLookPageOpened} from "../../../../../actions/lookFunctions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import LookFeatureImage from "../../../lookNavigation/lookMain/lookFeature/lookFeatureImage";
import FeatureName from "../../../../visComponents/featureName";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import FeatureDescription from "../../../../visComponents/featureDescription";


const GroheCartDesignRecommendedFeature = (props) => {

  const {feature, zoomToFeatureGroup, styles} = props;

  const featureClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartCheckoutSuccessFeature + Analytics.getSkuForAnalytics(feature));
    zoomToFeatureGroup(feature.partId, feature);
  }

  return (
    <div className="gc-recommended__feature" onClick={featureClick} style={styles || null}>
      <LookFeatureImage forFeature={feature} withoutGallery={true}/>
      <p className="h3 gc-recommended__feature-title">
        <FeatureName feature={feature} useCollectionName={true}/>
      </p>
      <div className="lm-feature__content-description gc-recommended__feature-description">
        <FeatureDescription feature={feature} brief={true}/>
      </div>
    </div>
  )
};

GroheCartDesignRecommendedFeature.propTypes = {
  feature: PropTypes.shape(featureInterface),
  zoomToFeatureGroup: PropTypes.func.isRequired,
  styles: PropTypes.object,
}

const mapStateToProps = (store) => {
  const {recentlyViewedItems} = store.cartState;
  return {
    recentlyViewedItems,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
  setLookOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartDesignRecommendedFeature)
)
